import { render, staticRenderFns } from "./AddContentCategoryComponent.vue?vue&type=template&id=06e58d75&scoped=true"
import script from "./AddContentCategoryComponent.vue?vue&type=script&lang=js"
export * from "./AddContentCategoryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e58d75",
  null
  
)

export default component.exports